export default __webpack_public_path__ + "static/media/avatar4.450f5e91.png";